import React, { useEffect, useState } from 'react';

import { CheckboxGroup } from '@chakra-ui/react';
import { fieldDefaultProps, fieldPropTypes, useField } from '@formiz/core';
import PropTypes from 'prop-types';

import { FormGroup } from '@/components';

export const FieldCheckboxGroup = (props) => {
  const {
    id,
    isValid,
    isSubmitted,
    resetKey,
    setValue,
    value,
    errorMessage,
  } = useField(props);

  const {
    colorScheme,
    label,
    helper,
    isDisabled,
    required,
    formatValue,
    keepValue,
    asyncValidations,
    children,
    ...otherProps
  } = props;

  const [isTouched, setIsTouched] = useState(false);
  const showError = !isValid && (isTouched || isSubmitted);

  const formGroupProps = {
    htmlFor: id,
    label,
    helper,
    errorMessage,
    showError,
    isRequired: !!required,
    isDisabled,
    ...otherProps,
  };

  useEffect(() => {
    setIsTouched(false);
  }, [resetKey]);

  const handleChange = (updatedValue) => {
    if (!isTouched) {
      setIsTouched(true);
    }
    setValue(updatedValue);
  };

  return (
    <FormGroup {...formGroupProps}>
      <CheckboxGroup
        colorScheme={colorScheme}
        value={value || []}
        onChange={handleChange}
        aria-invalid={showError}
        aria-required={!!required}
        aria-describedby={showError ? `${id}-error` : null}
      >
        {children}
      </CheckboxGroup>
    </FormGroup>
  );
};

FieldCheckboxGroup.propTypes = {
  colorScheme: PropTypes.string,
  label: PropTypes.string,
  helper: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  ...fieldPropTypes,
};

FieldCheckboxGroup.defaultProps = {
  colorScheme: 'brandSecondary',
  label: '',
  helper: '',
  isDisabled: false,
  children: null,
  ...fieldDefaultProps,
};
